import React, { useEffect, useRef, useState } from 'react'
import { Atom, Ban, Bell, BookA, BookOpenText, Calculator, Clock, Earth, Eye, Languages, Lock, LogOut, Microscope, Radical, Search, Settings, Swords } from 'lucide-react'
import { useUserContext } from '../contexts/user'
import { useQuizzesContext } from "../contexts/Quizzes";
import { useNavigate } from 'react-router-dom';
import isArabic from 'is-arabic';
import { usePopUpContext } from '../contexts/Popup';
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { get, onValue, ref, update } from 'firebase/database';
import { db } from '../Database';
import { useLoaderContext } from '../contexts/loader';
import { useCheckForNewToken } from '../checkForNewToken';

const HomePage = () => {
  const navigate = useNavigate();

  const { userInfo, userIndex, setUserInfo, supervisorStudent, setSupervisorStudent, userJWT, setUserJWT, setUser, setUserIndex, appLanguage } = useUserContext();
  const { quizzes } = useQuizzesContext();
  const { setMessageContent } = usePopUpContext();
  const { setIsLoading } = useLoaderContext();
  const { checkForNewToken } = useCheckForNewToken();

  const [render, setRender] = useState(0);
  const [searchResults, setSearchResults] = useState([]);
  const [showingTeacherQuizzes, setShowingTeacherQuizzes] = useState(false);
  const [teacherQuizzes, setTeacherQuizzes] = useState([]);
  const [choosedTab, setChoosedTab] = useState("solved quizzes");
  const [studentResults, setStudentResults] = useState([]);
  const [showSettings, setShowSettings] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [sendAnother, setSendAnother] = useState(false);
  const [analytics, setAnalytics] = useState({});

  const categories = [{
    en: "Science",
    ar: "علوم",
  }, {
    en: "Math",
    ar: "رياضيات",
  }, {
    en: "Arabic",
    ar: "عربي",
  }, {
    en: "English",
    ar: "إنجليزي",
  }, {
    en: "Social Studies",
    ar: "دراسات اجتماعية",
  }, {
    en: "French",
    ar: "فرنسي",
  }];

  const searchInputRef = useRef();
  const publicIDRef = useRef();

  const search = (e) => {
    let value = "";
    if (typeof e ===  "object" && e !== null && !e.target) {
      value = e.en.toLowerCase().trim();
    } else if (typeof e ===  "string") {
      value = e.toLowerCase().trim();
    } else {
      value = e.target.value.toLowerCase().trim();
    }
    setSearchResults([]);
    setShowingTeacherQuizzes(false);
    for (let i = 0; i < quizzes.length; i++) {
      if (quizzes[i].from_name.toLowerCase().trim().includes(value) || quizzes[i].description.toLowerCase().trim().includes(value) || quizzes[i].category.toLowerCase().trim().includes(value) || quizzes[i]._id.includes(value)) {
        setSearchResults(prev => ([...prev, quizzes[i]]))
      }
    }
  }

  const showTeacherQuizzes = () => {
    setSearchResults([]);
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    if (showingTeacherQuizzes) {
      setShowingTeacherQuizzes(false);
    } else {
      setShowingTeacherQuizzes(true);
      const teacher_quizzes = quizzes.filter(quiz => quiz.from_id ===  userInfo.id);
      setTeacherQuizzes(teacher_quizzes)
    }
  }

  useEffect(() => {
    if (userIndex !== -1) {
      if (userInfo.role ===  "student") {
        onValue(ref(db, "users/" + userInfo.id + "/notifications"), (snapShot) => {
          setUserInfo(prev => ({
            ...prev,
            notifications: snapShot.val(),
          }))
        })
      } else if (userInfo.role ===  "supervisor") {
        onValue(ref(db, "users/" + userInfo.id + "/superVisor"), (snapShot) => {
          setUserInfo(prev => ({
            ...prev,
            superVisor: snapShot.val(),
          }))
          if (!snapShot.val().includes("waiting") && !snapShot.val().includes("rejected")) {
            setSupervisorStudent({
              waiting: false,
              rejected: false,
            })
            if (!studentResults.length) {
              setIsLoading(prev => prev + 1);
              fetch("https://quiz-battle-api.vercel.app/api/user-data", {
                method: "GET",
                credentials: "include",
                headers: {
                  "Authorization": `Bearer ${userJWT}`,
                  "Content-Type": "application/json",
                },
              }).then(res => res.json())  
              .then(data => {
                checkForNewToken(data, setUserJWT, setUserInfo, setUser, setUserIndex, navigate, setMessageContent);
                setUserInfo({
                  ...data.userData
                })
                setSupervisorStudent({
                  ...data.userData.superVisorData
                })
                setIsLoading(prev => prev !== 0 ? prev-- : 0);
              }).catch(err => {
                setMessageContent({
                  title: "Fetching failed",
                  message: "Oops! something went wrong while fetching your student data.",
                })
                setIsLoading(prev => prev !== 0 ? prev-- : 0);
              })
              fetch("https://quiz-battle-api.vercel.app/api/get-student-results", {
                method: "GET",
                credentials: "include",
                headers: {
                  "Authorization": `Bearer ${userJWT}`,
                  "Content-Type": "application/json",
                },
              }).then(res => res.json())
                .then((data) => {
                  checkForNewToken(data, setUserJWT, setUserInfo, setUser, setUserIndex, navigate, setMessageContent);
                  setStudentResults(data.results || []);
                  setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                }).catch(() => {
                  setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
                  setMessageContent({
                    title: appLanguage ===  "ar" ? "خطأ في جلب النتائج" : "Fetching Results Error",
                    message: appLanguage ===  "ar" ? "حدث خطأ أثناء جلب نتائج طالبك." : "Oops! something went wrong while fetching your student results.",
                  })
                })
            }
          } else if (snapShot.val().includes("waiting")) {
            setSupervisorStudent({
              waiting: true,
              rejected: false,
            })
          } else {
            setSupervisorStudent({
              waiting: false,
              rejected: true,
            })
          }
        })
      } else {
        setRender(prev => prev + 1);
      }
    }
  }, [userIndex])

  useEffect(() => {
    if (quizzes.length && studentResults.length) {
      let analytics = {};
      let solvedQuizzesIDs = studentResults.map(result => {
        return result.quiz_id;
      })
      let solvedQuizzes = quizzes?.filter(quiz => solvedQuizzesIDs.includes(quiz._id));
      for (let i = 0; i < solvedQuizzes.length; i++) {
        const quiz = solvedQuizzes[i];
        const studentResult = studentResults[studentResults.findIndex(result => result.quiz_id ===  quiz._id)];
        const percentage = Math.round(studentResult.points / (quiz.questions.length * 5) * 100);
        let analytic = analytics[solvedQuizzes[i].category.toLowerCase().replace(" ", "_")] || {};
        analytic.percentages = analytic.percentages ? [...analytic.percentages, percentage] : [percentage];
        analytic.totalSum = analytic.totalSum ? analytic.totalSum + quiz.questions.length * 5 : quiz.questions.length * 5;
        analytic.collectedPoints = analytic.collectedPoints ? analytic.collectedPoints + studentResult.points : studentResult.points;
        analytics[solvedQuizzes[i].category.toLowerCase().replace(" ", "_")] = analytic;
      }
      setAnalytics(analytics);
    }
  }, [quizzes, studentResults])

  const acceptSupervisor = (index) => {
    setIsLoading(prev => prev + 1);
    update(ref(db, "users/" + userInfo.notifications[index].id), {
      superVisor: userInfo.public_id,
    }).then(() => {
      const notifications = [...userInfo.notifications];
      notifications.splice(index, 1);
      update(ref(db, "users/" + userInfo.id), { notifications }).then(() => {
        setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
      })
    }).catch(() => {
      setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
      setMessageContent({
        title: appLanguage ===  "ar" ? "خطأ في القبول" : "Acception Error",
        message: appLanguage ===  "ar" ? "حدث خطأ أثناء قبول المشرف." : "Oops! something went wrong while accepting the supervisor.",
      })
    })
  }

  const rejectSupervisor = (index) => {
    setIsLoading(prev => prev + 1);
    update(ref(db, "users/" + userInfo.notifications[index].id), {
      superVisor: "rejected " + userInfo.public_id,
    }).then(() => {
      const notifications = [...userInfo.notifications];
      notifications.splice(index, 1);
      update(ref(db, "users/" + userInfo.id), { notifications }).then(() => {
        setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
      })
    }).catch(() => {
      setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
      setMessageContent({
        title: appLanguage ===  "ar" ? "خطأ في الرفض" : "Rejection Error",
        message: appLanguage ===  "ar" ? "حدث خطأ أثناء رفض المشرف." : "Oops! something went wrong while rejecting the supervisor.",
      })
    })
  }

  const resendSupervisorMessage = () => {
    const studentPublicID = userInfo.superVisor.split(" ")[1];
    setIsLoading(prev => prev + 1);
    fetch("https://quiz-battle-api.vercel.app/api/send-supervisor-request" , {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${userJWT}`,
      },
      body: JSON.stringify({
        public_id: studentPublicID,
      }),
    }).then(res => res.json())
    .then(data => {
      checkForNewToken(data, setUserJWT, setUserInfo, setUser, setUserIndex, navigate, setMessageContent);
      setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
      if(data.failed) {
        setMessageContent({
          title: appLanguage === "ar" ? "فشل الطلب" : "Requesting Failed",
          message: appLanguage === "ar" ? "فشل إرسال طلبك الى الطالب" : "Failed to send your request",
        })
      }else {
        setMessageContent({
          title: appLanguage === "ar" ? "تم الإرسال" : "Request Sent",
          message: appLanguage === "ar" ? "تم إرسال طلبك بنجاح" : "Your request has been sent successfully!",
        })
        setUserInfo(prev => ({
          ...prev,
          superVisor: "waiting " + studentPublicID,
        }))
      }
    }).catch(err => {
      setMessageContent({
        title: appLanguage === "ar" ? "فشل الطلب" : "Requesting Failed",
        message: appLanguage === "ar" ? "فشل إرسال طلبك الى الطالب" : "Failed to send your request",
      })
      setIsLoading(prev => prev !== 0 ? prev-- : 0);
    })
  }

  const chooseColor = (percent) => {
    if (percent >= 80) return "#0b0"
    else if (percent >= 50) return "#f90"
    else return "#f00";
  }

  const sendAnotherRequest = () => {
    const id = publicIDRef.current.value.trim();
    if (id) {
      setIsLoading(prev => prev + 1);
      fetch("https://quiz-battle-api.vercel.app/api/send-supervisor-request" , {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${userJWT}`,
        },
        body: JSON.stringify({
          public_id: id,
        }),
      }).then(res => res.json())
      .then(data => {
        checkForNewToken(data, setUserJWT, setUserInfo, setUser, setUserIndex, navigate, setMessageContent);
        setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
        if (data.failed) {
          setMessageContent({
            title: "Sending Request Error",
            message: "Oops! something went wrong while sending your request to the target user.",
          })
        } else {
          setMessageContent({
            title: "Request sent!",
            message: "Your request has been sent to the target student.",
          })
        }
      }).catch(() => {
        setIsLoading(prev => prev !== 0 ? prev - 1 : 0);
        setMessageContent({
          title: "Sending Request Error",
          message: "Oops! something went wrong while sending your request to the target user.",
        })
      })
    } else {
      setMessageContent({
        title: appLanguage ===  "ar" ? "الهوية فارغة" : "Empty ID",
        message: appLanguage ===  "ar" ? "هل تحاول إرسال طلب إلى شبح؟" : "Are you trying to send a request to a ghost?",
      })
    }
  }

  const logout = () => {
    setUserJWT("");
    setUser("");
    setUserIndex(-1);
    setUserInfo({});
    localStorage.removeItem("user token");
    localStorage.removeItem("user");
    setSupervisorStudent({});
    setStudentResults([]);
    setAnalytics({});
    setIsLoading(0);
    navigate("/sign-in");
  }

  return (
    <div className="home_page_container">
      {
        userInfo.role !== "supervisor" ?
          <>
            <header>
              <p className="website_name">Quiz Battle</p>
              <div className="search">
                <Search size={18} color="#666" />
                <input ref={searchInputRef} type="search" onChange={(e) => { search(e); isArabic(e.target.value.split(" ")[0], { count: 0, }) ? e.target.dir = "rtl" : e.target.dir = "ltr" }} placeholder={appLanguage ===  "ar" ? "بحث" : "Search"} />
              </div>
            </header>
            {
              userInfo.role ===  "teacher" ?
                <>
                  <div className="new_quiz">
                    <button id="create_quiz" onClick={() => navigate("/create")}>{appLanguage ===  "ar" ? "إنشاء اختبار" : "Create Quiz"}</button>
                    <button id="live_challenge" onClick={() => navigate("/live-challenge/create")}>{appLanguage ===  "ar" ? "تحدي مباشر" : "Live Challenge"}</button>
                  </div>
                  <button id="my_quizzes" onClick={showTeacherQuizzes}>{showingTeacherQuizzes ? (appLanguage ===  "ar" ? "إلغاء" : "Cancel") : (appLanguage ===  "ar" ? "اختباراتي" : "My Quizzes")}</button>
                </>
                : undefined
            }
            {userInfo.role ===  "student" ? <button id="live_challenge" onClick={() => navigate("/live-challenge/join")}>{appLanguage ===  "ar" ? "تحدي مباشر" : "Live Challenge"}</button> : undefined}
            <a href="https://quiz-battle-connect.netlify.app" className="community-btn" target="_blank" rel="noreferrer">
              <div className="icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="text-container">
                <span className="label">Quiz Battle Connect</span>
                <span className="sub-label">
                  <span className="badge-dot"></span>
                  Your perspective is the missing piece. Join the conversation.
                </span>
              </div>
            </a>
            <div className="categories">
              <div className="categories-title" dir={appLanguage ===  "ar" ? "rtl" : "ltr"}>{appLanguage ===  "ar" ? "الفئات" : "Categories"}</div>
              <div className="content">
                {
                  categories.map((category, i) => {
                    const categoryName = appLanguage ===  "ar" ? category.ar : category.en;
                    return (
                      <div onClick={() => { searchInputRef.current.focus(); searchInputRef.current.value = categoryName; search(category) }} key={"category_" + i} className={"category " + category.en.replace(" ", "_").toLowerCase()}>
                        <div className="icons">
                          {category.en ===  "Science" ?
                            <>
                              <div className="icon"><Microscope size={60} /></div>
                              <div className="icon"><Atom size={60} /></div>
                            </>
                            : (
                              category.en ===  "Math" ?
                                <>
                                  <div className="icon"><Calculator size={60} /></div>
                                  <div className="icon"><Radical size={60} /></div>
                                </>
                                :
                                (category.en ===  "Social Studies" ?
                                  <>
                                    <div className="icon"><Swords size={60} /></div>
                                    <div className="icon"><Earth size={60} /></div>
                                  </>
                                  : (
                                    category.en ===  "English" ?
                                      <>
                                        <div className="icon"><Languages size={60} /></div>
                                        <div className="icon"><BookA size={60} /></div>
                                      </>
                                      :
                                      (
                                        category.en ===  "French" ?
                                          <>
                                            <div className="icon"><Languages size={60} /></div>
                                            <div className="icon"><BookOpenText size={60} /></div>
                                          </>
                                          :
                                          <>
                                            <div className="icon"><BookOpenText size={60} /></div>
                                            <div className="icon"><Languages size={60} /></div>
                                          </>
                                      )
                                  )
                                )
                            )
                          }
                        </div>
                        <div className="title">{categoryName}</div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <div className="student_buttons">
              {userInfo.role ===  "student" ? <button className={showNotifications ? "active" : ""} onClick={() => { setShowNotifications(prev => !prev); setShowSettings(false) }}><Bell /> {userInfo.notifications ? <span></span> : undefined}</button> : undefined}
              <button className={showSettings ? "active" : ""} onClick={() => { setShowNotifications(false); setShowSettings(prev => !prev) }}><Settings /></button>
            </div>
            {showSettings || showNotifications ?
              <div className="settings_and_notifications">
                {
                  showNotifications ? userInfo.notifications ? userInfo.notifications.map((notification, i) => {
                    return <div className="notification" key={"notification_" + i}>
                      <p className="text">{notification.text}</p>
                      <div className="notification_buttons">
                        <button className="accept" onClick={() => acceptSupervisor(i)}>{appLanguage ===  "ar" ? "قبول" : "Accept"}</button>
                        <button className="reject" onClick={() => rejectSupervisor(i)}>{appLanguage ===  "ar" ? "رفض" : "Reject"}</button>
                      </div>
                    </div>
                  }) : <p className="no_notifications" dir={appLanguage ===  "ar" ? "rtl" : "ltr"}>{appLanguage ===  "ar" ? "لا توجد إشعارات" : "No Notifications Found"}</p>
                    : <>
                      {userInfo.role ===  "student" ? <p className="public_id">{userInfo.public_id}</p> : undefined}
                      <button className="logout" onClick={logout}>{appLanguage ===  "ar" ? "تسجيل الخروج" : "Logout"} <LogOut size={16} strokeWidth={3} /></button>
                    </>
                }
              </div> : undefined}
            <div className="quizzes">
              <div className="quiz_title" dir={appLanguage ===  "ar" ? "rtl" : "ltr"}>{appLanguage ===  "ar" ? "الاختبارات" : "Quizzes"}</div>
              <div className="content">
                {
                  quizzes.length ?
                    (
                      searchInputRef.current && searchInputRef.current.value && searchInputRef.current.value.trim().length ?
                        (
                          searchResults.length ?
                            searchResults.map((quiz, i) => {
                              return (
                                <div className="quiz" key={"Quiz_" + i}>
                                  {quiz.password ? <div className="locked"><Lock size={18} strokeWidth={3} /></div> : undefined}
                                  <div className="main_content">
                                    <p className="title">{quiz.category}</p>
                                    <p className="teacher_name">{quiz.from_name}</p>
                                    <p className="questions_number">{quiz.questions.length} {appLanguage ===  "ar" ? "سؤال" : "Questions"}</p>
                                    <p className="description">{quiz.description ? quiz.description : (appLanguage ===  "ar" ? "لا يوجد وصف" : "No Description Provided")}</p>
                                  </div>
                                  {quiz.from_id ===  userInfo.id ? <button className="details" onClick={() => navigate("/details/" + quiz._id)}>{appLanguage ===  "ar" ? "تفاصيل الاختبار" : "Quiz Details"}</button> : <button className="start" onClick={() => { userInfo.role ===  "student" ? navigate("/info/" + quiz._id) : setMessageContent({ title: appLanguage ===  "ar" ? "الوصول مرفوض" : "Access Denied", message: appLanguage ===  "ar" ? "يمكن للطلاب فقط الوصول إلى الاختبارات." : "Only the students can access the quizzes.", }) }}>{appLanguage ===  "ar" ? "بدء الاختبار" : "Start Quiz"}</button>}
                                </div>
                              )
                            })
                            : <p className="no_search_results" dir={appLanguage ===  "ar" ? "rtl" : "ltr"}>{appLanguage ===  "ar" ? `لم يتم العثور على نتائج لـ "${searchInputRef.current.value}". جرب شيئًا آخر.` : `No Results Found For "${searchInputRef.current.value}" . Try something else.`}</p>
                        )
                        : (
                          showingTeacherQuizzes ?
                            (
                              teacherQuizzes.length ?
                                teacherQuizzes.map((quiz, i) => {
                                  return (
                                    <div className="quiz" key={"Quiz_" + i}>
                                      {quiz.password ? <div className="locked"><Lock size={18} strokeWidth={3} /></div> : undefined}
                                      <div className="main_content">
                                        <p className="title">{quiz.category}</p>
                                        <p className="teacher_name">{quiz.from_name}</p>
                                        <p className="questions_number">{quiz.questions.length} {appLanguage ===  "ar" ? "سؤال" : "Questions"}</p>
                                        <p className="description">{quiz.description ? quiz.description : (appLanguage ===  "ar" ? "لا يوجد وصف" : "No Description Provided")}</p>
                                      </div>
                                      {quiz.from_id ===  userInfo.id ? <button className="details" onClick={() => navigate("/details/" + quiz._id)}>{appLanguage ===  "ar" ? "تفاصيل الاختبار" : "Quiz Details"}</button> : <button className="start" onClick={() => { userInfo.role ===  "student" ? navigate("/info/" + quiz._id) : setMessageContent({ title: appLanguage ===  "ar" ? "الوصول مرفوض" : "Access Denied", message: appLanguage ===  "ar" ? "يمكن للطلاب فقط الوصول إلى الاختبارات." : "Only the students can access the quizzes.", }) }}>{appLanguage ===  "ar" ? "بدء الاختبار" : "Start Quiz"}</button>}
                                    </div>
                                  )
                                })
                                : <p className="no_quizzes">{appLanguage ===  "ar" ? "ليس لديك أي اختبارات بعد." : "You dont't have any quizzes yet."}</p>
                            )
                            : quizzes.map((quiz, i) => {
                              return (
                                <div className="quiz" key={"Quiz_" + i}>
                                  {quiz.password ? <div className="locked"><Lock size={18} strokeWidth={3} /></div> : undefined}
                                  <div className="main_content">
                                    <p className="title">{quiz.category}</p>
                                    <p className="teacher_name">{quiz.from_name}</p>
                                    <p className="questions_number">{quiz.questions ? quiz.questions.length : 0} {appLanguage ===  "ar" ? "سؤال" : "Questions"}</p>
                                    <p className="description" dir={quiz.description ? (isArabic(quiz.description.split(" ")[0], { count: 0, }) ? "rtl" : "ltr") : "ltr"}>{quiz.description ? quiz.description : (appLanguage ===  "ar" ? "لا يوجد وصف" : "No Description Provided")}</p>
                                  </div>
                                  {quiz.from_id ===  userInfo.id ? <button className="details" onClick={() => navigate("/details/" + quiz._id)}>{appLanguage ===  "ar" ? "تفاصيل الاختبار" : "Quiz Details"}</button> : <button className="start" onClick={() => { userInfo.role ===  "student" ? navigate("/info/" + quiz._id) : setMessageContent({ title: appLanguage ===  "ar" ? "الوصول مرفوض" : "Access Denied", message: appLanguage ===  "ar" ? "يمكن للطلاب فقط الوصول إلى الاختبارات." : "Only the students can access the quizzes.", }) }}>{appLanguage ===  "ar" ? "بدء الاختبار" : "Start Quiz"}</button>}
                                </div>
                              )
                            })
                        )
                    )
                    : <p className="no_quizzes" dir={appLanguage ===  "ar" ? "rtl" : "ltr"}>{appLanguage ===  "ar" ? "لا توجد اختبارات متاحة حاليًا. يرجى التحقق لاحقًا!" : "No quizzes available at the moment. Please check back later!"}</p>
                }
              </div>
            </div>
          </> : <>
            <header>
              <p className="title">{appLanguage ===  "ar" ? "مشرف" : "Supervisor"}</p>
              <button onClick={logout}>{appLanguage ===  "ar" ? "تسجيل الخروج" : "Logout"}</button>
            </header>
            <div className="student_details">
              <div className="detail">
                <p className="key">{appLanguage ===  "ar" ? "اسم الطالب" : "Student Name"}</p>
                <p className="value">{supervisorStudent.username}</p>
              </div>
              <div className="detail">
                <p className="key">{appLanguage ===  "ar" ? "الهوية العامة" : "Public ID"}</p>
                <p className="value">{supervisorStudent.public_id}</p>
              </div>
              <div className="detail">
                <p className="key">{appLanguage ===  "ar" ? "الاختبارات المحلولة" : "Solved Quizzes"}</p>
                <p className="value">{supervisorStudent.rejected || supervisorStudent.waiting ? "--" : (studentResults.length)}</p>
              </div>
              <div className="detail">
                <p className="key">{appLanguage ===  "ar" ? "فى إختبار" : "Solving Quiz"}</p>
                <p className={"value " + (supervisorStudent.rejected || supervisorStudent.waiting ? "" : (supervisorStudent.playingQuiz ? "yes" : "no"))}>{supervisorStudent.rejected || supervisorStudent.waiting ? "--" : (supervisorStudent.playingQuiz ? (appLanguage ===  "ar" ? "نعم" : "Yes") : (appLanguage ===  "ar" ? "لا" : "No"))}</p>
              </div>
              <div className="detail">
                <p className="key">{appLanguage ===  "ar" ? "في تحدي" : "In Challenge"}</p>
                <p className={"value " + (supervisorStudent.rejected || supervisorStudent.waiting ? "" : (supervisorStudent.challenge ? "yes" : "no"))}>{supervisorStudent.rejected || supervisorStudent.waiting ? "--" : (supervisorStudent.challenge ? (appLanguage ===  "ar" ? "نعم" : "Yes") : (appLanguage ===  "ar" ? "لا" : "No"))}</p>
              </div>
            </div>
            <div className="choose_buttons">
              <button onClick={() => setChoosedTab("solved quizzes")} className={choosedTab ===  "solved quizzes" ? "active" : ""}>{appLanguage ===  "ar" ? "الاختبارات المحلولة" : "Solved Quizzes"}</button>
              <button onClick={() => setChoosedTab("analytics")} className={choosedTab ===  "analytics" ? "active" : ""}>{appLanguage ===  "ar" ? "التحليلات" : "Analytics"}</button>
            </div>
            {
              supervisorStudent.rejected ? <div className="rejected">
                <Ban color='#ff0000' strokeWidth={3} size={50} />
                <p>{appLanguage ===  "ar" ? "تم رفض طلبك" : "Your request was rejected"}</p>
                <div className="content">
                  {sendAnother ?
                    <>
                      <input ref={publicIDRef} type="text" placeholder={appLanguage ===  "ar" ? "أدخل هوية الطالب العامة" : "Enter student public ID"} />
                      <div className="send_another_buttons">
                        <button onClick={sendAnotherRequest}>{appLanguage ===  "ar" ? "إرسال الطلب" : "Send Request"}</button>
                        <button onClick={() => setSendAnother(false)}>{appLanguage ===  "ar" ? "إلغاء" : "Cancel"}</button>
                      </div>
                    </>
                    : <>
                      <button onClick={resendSupervisorMessage}>{appLanguage ===  "ar" ? "إعادة الإرسال" : "Resend"}</button>
                      <button onClick={() => setSendAnother(true)}>{appLanguage ===  "ar" ? "أدخل هوية عامة أخرى" : "Enter another public ID"}</button></>}
                </div>
              </div>
                : (
                  supervisorStudent.waiting ? <div className="waiting">
                    <Clock size={50} color={"#ffffff77"} />
                    <p>{appLanguage ===  "ar" ? "في انتظار قبول طلبك" : "Wating to accept your request"}</p>
                  </div> : (choosedTab ===  "solved quizzes" ?
                    <div className="solved_quizzes">
                      <>
                        {
                          quizzes.length && studentResults && studentResults.length ? studentResults.map((result, i) => {
                            let quiz = quizzes.find(quiz => quiz._id ===  result.quiz_id);
                            return <div className="quiz" key={"result_" + i}>
                              <div className="left_side">
                                <div className={"quiz_icon " + quiz?.category.toLowerCase().replace(" ", "_")}>
                                  {quiz?.category.toLowerCase() ===  "arabic" || quiz?.category.toLowerCase() ===  "english" || quiz?.category.toLowerCase() ===  "french" ? <Languages size={30} /> : (quiz?.category.toLowerCase() ===  "math" ? <Calculator size={30} /> : (quiz?.category.toLowerCase() ===  "science" ? <Atom size={30} /> : <Earth size={30} />))}
                                </div>
                                <div className="data">
                                  <p>{quiz ? quiz.category : (appLanguage ===  "ar" ? "محذوف " : "Deleted ")} {appLanguage ===  "ar" ? "اختبار" : "quiz"}</p>
                                  <p>{quiz.from_name}</p>
                                </div>
                              </div>
                              <div className="right_side">
                                <p className="percent" style={{ color: "#fff", }}><p>{Math.round(result.points / (quiz.questions.length * 5) * 100)}%</p> <span style={{ width: Math.round(result.points / (quiz.questions.length * 5) * 100) + "%", backgroundColor: chooseColor(Math.round(result.points / (quiz.questions.length * 5) * 100)), }}></span></p>
                              </div>
                            </div>
                          })
                            : <p className="no_solved_quizzes">{appLanguage ===  "ar" ? "لا توجد نتائج" : "No Results Found"}</p>
                        }
                      </>
                    </div> :
                    <div className="analytics_container">
                      {
                        Object.keys(analytics).map((key, i) => {
                          return (
                            <div className="subject_analytics" key={"key_" + i}>
                              <p className="distribution_title arabic">{key} {appLanguage ===  "ar" ? "تحليلات" : "Analytics"}</p>
                              <div className="content">
                                <div className="score_distribution">
                                  <p className="title">{appLanguage ===  "ar" ? "توزيع النقاط" : "Score Distribution"}</p>
                                  <div className="distributions">
                                    <div className="distribution first">
                                      <p className="percentages">80-100%</p>
                                      <div className="percentage">
                                        <div><span style={{ width: Math.round(analytics[key].percentages.filter(percentage => percentage >= 80).length / analytics[key].percentages.length * 100) + "%", }}></span></div>
                                        <p>{Math.round(analytics[key].percentages.filter(percentage => percentage >= 80).length / analytics[key].percentages.length * 100)}%</p>
                                      </div>
                                    </div>
                                    <div className="distribution second">
                                      <p className="percentages">50-79%</p>
                                      <div className="percentage">
                                        <div><span style={{ width: Math.round(analytics[key].percentages.filter(percentage => percentage >= 50 && percentage <= 79).length / analytics[key].percentages.length * 100) + "%", }}></span></div>
                                        <p>{Math.round(analytics[key].percentages.filter(percentage => percentage >= 50 && percentage <= 79).length / analytics[key].percentages.length * 100)}%</p>
                                      </div>
                                    </div>
                                    <div className="distribution third">
                                      <p className="percentages">0-49%</p>
                                      <div className="percentage">
                                        <div><span style={{ width: Math.round(analytics[key].percentages.filter(percentage => percentage < 50).length / analytics[key].percentages.length * 100) + "%" }}></span></div>
                                        <p>{Math.round(analytics[key].percentages.filter(percentage => percentage < 50).length / analytics[key].percentages.length * 100)}%</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="average_score">
                                  <p className="title">{appLanguage ===  "ar" ? "متوسط النقاط" : "Average Score"}</p>
                                  <div className="circular_progress_bar">
                                    <CircularProgressbar text={Math.round(analytics[key].collectedPoints / analytics[key].totalSum * 100) + "%"} styles={buildStyles({
                                      pathColor: "#00f1a1",
                                      textColor: "#FFF",
                                      trailColor: "#FFFFFF33",
                                    })} value={Math.round(analytics[key].collectedPoints / analytics[key].totalSum * 100)} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  )
                )}
          </>
      }
    </div>
  )
}

export default HomePage